import React, { useCallback, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { fromEvent } from "rxjs";
import { registerApplication, getAppStatus, AppProps } from "single-spa";
import singleSpaReact from "single-spa-react";

interface PageAppProps {
  name: string;
  component: Promise<unknown>;
  onLoading: (state: boolean) => void;
  activeWhen: string;
}

export default function PageApp(props: PageAppProps): JSX.Element {
  const { name, component, activeWhen, onLoading } = props;
  const [status, setStatus] = useState("");

  useEffect(() => {
    const subscription = fromEvent(
      window,
      "single-spa:routing-event"
    ).subscribe(() => setStatus(getAppStatus(name).toLowerCase()));
    return () => subscription.unsubscribe();
  }, [name]);

  const load = useCallback(() => {
    onLoading(true);
    return component
      .finally(() => onLoading(false))
      .then((c: { default: React.FunctionComponent<AppProps> }) =>
        singleSpaReact({
          React,
          ReactDOM,
          rootComponent: c.default,
        })
      );
  }, [onLoading, component]);

  useEffect(() => {
    registerApplication({
      name,
      app: load,
      activeWhen,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className={`spa ${status}`} id={`single-spa-application:${name}`} />
  );
}
